import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SendEmailService } from './send-email.service';
import { FailureBoxComponent } from '../failure-box/failure-box.component';

@Component({
    selector: 'logzy-send-email-confirmation',
    templateUrl: './send-email-confirmation.component.html',
    styleUrls: ['./send-email-confirmation.component.scss']
})
export class SendEmailConfirmationComponent implements OnInit {

    @Output() emailSend = new EventEmitter<void>();

    disableSave: boolean = false;

    @Input() loading: boolean = false;

    sendQuoteEmailBody: {} = null;

    @Input() usersList: [] = [];
    @Input() userListKey: string = null;
    @Input() contentURL: string = null;
    @Input() contentKeys: [] = [];

    sendEmailForm;
    // chipCtrl = new FormControl();
    chips: string[] = [];
    allOptions: string[] = [];
    selectable = true;
    removable = true;
    showOptions = false;
    subject: string = '';
    content: SafeHtml = '';
    contentBody: string = '';
    submitted = false;
    extractedStyles: string = '';
    snackBarMessage: string = '';
    mailType: string = '';

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<SendEmailConfirmationComponent>,
        private snackBar: MatSnackBar, public fb: FormBuilder,
        private dialog: MatDialog,
        private sanitizer: DomSanitizer, private sendEmailService: SendEmailService,
    ) { }

    ngOnInit(): void {
        this.extractedStyles = '';
        this.sendEmailForm = this.fb.group({
            chipCtrl: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]]
            // subject: new FormControl('', [Validators.required])
        });

        console.log(this.data);
        this.chips = [];
        this.allOptions = this.data.usersList;
        if (this.allOptions.length != 0) {
            this.allOptions.map(users => {
                this.chips.push(users);
            })
        }
        this.subject = this.data.contentKeys.subject;
        this.content = this.sanitizer.bypassSecurityTrustHtml(this.data.contentKeys.content);
        this.contentBody = this.data.contentKeys.content;
        this.snackBarMessage = this.data.snackBarMessage;
        this.mailType = this.data.mailType;
        this.contentURL = this.data.contentURL;

    }

    get myForm() {
        return this.sendEmailForm.controls;
    }

    get filteredOptions(): string[] {
        const inputText = (this.sendEmailForm.controls['chipCtrl'].value || '').toLowerCase(); // Use guard clause to handle null/undefined
        return this.showOptions ? this.allOptions.filter(option => option.toLowerCase().includes(inputText) && !this.chips.includes(option)) : [];
    }

    selected(event: any): void {
        this.chips.push(event.option.viewValue);
        this.sendEmailForm.controls['chipCtrl'].setValue('');
    }

    remove(chip: string): void {
        const index = this.chips.indexOf(chip);
        if (index >= 0) {
            this.chips.splice(index, 1);
        }
    }

    addNewChip(): void {
        this.submitted = true;
        if (this.sendEmailForm.valid) {
            const inputValue = this.sendEmailForm.controls['chipCtrl'].value?.trim();
            if (inputValue && !this.chips.includes(inputValue)) {
                this.chips.push(inputValue);
            }
            this.sendEmailForm.controls['chipCtrl'].setValue('');
        }
    }

    sendConfirmationEmail() {
        this.sendQuoteEmailBody = {
            to_emails: this.chips,
            subject: this.subject,
            content: this.contentBody
        };
        console.log(this.sendQuoteEmailBody);

        this.sendEmailService.sendConfirmationEmail(this.sendQuoteEmailBody, this.contentURL).subscribe({
            next: response => {
                this.snackBar.open(this.snackBarMessage, 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                this.dialogRef.close();
                this.emailSend.emit();
                this.disableSave = false;
                return response;
            },
            error: error => {
                if (error.status > 399 && error.status < 500) {
                    this.openFailureDialog('', error.error.detail);
                } else if (error.status >= 500) {
                    this.snackBar.open("Something went wrong!! Please try again after sometime.", 'Close', {
                        verticalPosition: 'top',
                        duration: 3000,
                    });
                }
                this.disableSave = false;
            }
        });
    }

    openFailureDialog(label: string, description, action: string = null) {
        const dialogRef = this.dialog.open(FailureBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: { subTitle: label, description: description, label1: action }
        });

        dialogRef.afterClosed().subscribe(item => {

        });
    }
    showAllOptions(): void {
        this.showOptions = true;
    }
}
